"use-strict";

function renderMinicartSections(cart, sections) {
  if (!cart?.getSectionsToRender || !sections) return false;

  let didRender = false;

  cart.getSectionsToRender().forEach((section) => {
    const elementToReplace = document.getElementById(section.id);
    const sectionMarkup = sections[section.id];
    if (!elementToReplace || !sectionMarkup) return;

    const html = new DOMParser().parseFromString(sectionMarkup, "text/html");
    const nextSection = html.querySelector(`#${section.id}`);
    if (!nextSection) return;

    elementToReplace.innerHTML = nextSection.innerHTML;
    didRender = true;
  });

  return didRender;
}

function updateMinicartCountdown(cart, sections) {
  const countdown = cart?.querySelector(".cart-countdown-time");
  const sectionMarkup = sections?.["minicart-form"];
  if (!countdown || !sectionMarkup) return;

  const html = new DOMParser().parseFromString(sectionMarkup, "text/html");
  const nextCountdown = html.querySelector(".cart-countdown-time");
  if (nextCountdown) {
    countdown.innerHTML = nextCountdown.innerHTML;
  }
}

const mobileProductSummaryMediaQuery = window.matchMedia("(max-width: 767.98px)");
let mobileProductSummaryFrame = 0;

function getMobileProductSummaryItems(productContainer) {
  return [...productContainer.querySelectorAll("[data-mobile-product-summary-item]")]
    .sort((firstItem, secondItem) => {
      const firstOrder = Number(firstItem.dataset.mobileProductSummaryOrder || 0);
      const secondOrder = Number(secondItem.dataset.mobileProductSummaryOrder || 0);
      return firstOrder - secondOrder;
    });
}

function syncMobileProductSummary(scope = document) {
  if (!scope?.querySelectorAll) return;

  const productContainers = scope.querySelectorAll(".sec__featured-product .main-product");
  if (productContainers.length === 0) return;

  productContainers.forEach((productContainer) => {
    const summaryContainer = productContainer.querySelector("[data-mobile-product-summary]");
    if (!summaryContainer) return;

    const items = getMobileProductSummaryItems(productContainer);
    if (items.length === 0) return;

    if (mobileProductSummaryMediaQuery.matches) {
      items.forEach((item) => {
        summaryContainer.appendChild(item);
      });
      return;
    }

    items.forEach((item) => {
      const itemKey = item.dataset.mobileProductSummaryItem;
      const anchor = productContainer.querySelector(
        `[data-mobile-product-summary-anchor="${itemKey}"]`
      );
      if (anchor) {
        anchor.after(item);
      }
    });
  });
}

function queueMobileProductSummarySync(scope = document) {
  if (mobileProductSummaryFrame) {
    window.cancelAnimationFrame(mobileProductSummaryFrame);
  }

  mobileProductSummaryFrame = window.requestAnimationFrame(() => {
    syncMobileProductSummary(scope);
    mobileProductSummaryFrame = 0;
  });
}

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.openContentMobile();
  }
  init() {
    this.syncStickyCartHeight();
    this.getHeightAddToCart();
    const btn_minimal = this.querySelector("minimal-button");
    if (btn_minimal) {
      btn_minimal.addEventListener("click", this.toggle.bind(this), false);
    }
  }
  syncStickyCartHeight() {
    const updateHeight = () => {
      if (this.stickyCartHeightFrame) {
        window.cancelAnimationFrame(this.stickyCartHeightFrame);
      }

      this.stickyCartHeightFrame = window.requestAnimationFrame(() => {
        const styles = window.getComputedStyle(this);
        const height = styles.display === "none" ? 0 : Math.ceil(this.getBoundingClientRect().height);

        document.documentElement.style.setProperty("--sticky-add-cart-height", `${height}px`);
        this.stickyCartHeightFrame = 0;
      });
    };

    updateHeight();

    if (window.ResizeObserver) {
      this.stickyCartResizeObserver = new ResizeObserver(updateHeight);
      this.stickyCartResizeObserver.observe(this, { box: "border-box" });
    }

    this.stickyCartMutationObserver = new MutationObserver(updateHeight);
    this.stickyCartMutationObserver.observe(this, {
      attributes: true,
      attributeFilter: ["class", "style", "hidden"],
      subtree: true,
    });

    window.addEventListener("resize", updateHeight);
    this.updateStickyCartHeight = updateHeight;
  }
  getHeightAddToCart() {
    const _this = this;
    this.main = this.closest(".sec__featured-product");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector(".button-trigger__sticky");

    if (!primaryBtn) return;

    var isVisible = true;
    function checkStickyVisibility() {
      var buttonRect = primaryBtn.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      if (
        !isVisible &&
        buttonRect.top < viewportHeight &&
        buttonRect.bottom > 0
      ) {
        isVisible = true;
        _this.classList.remove("show-sticky-cart");
        _this.updateStickyCartHeight?.();
      } else if (isVisible && buttonRect.bottom <= 0) {
        isVisible = false;
        _this.classList.add("show-sticky-cart");
        _this.updateStickyCartHeight?.();
      }
    }
    window.addEventListener("scroll", checkStickyVisibility);
    checkStickyVisibility();
  }
  toggle(e) {
    const target = e.currentTarget;
    target.classList.toggle("opened");
    if (!target) return;
    const parent = target.closest("sticky-add-cart");
    if (!parent) return;
    const content = parent.querySelector(".content--expand");
    slideAnime({
      target: content,
      animeType: "slideToggle",
    });
  }
  openContentMobile() {
    const _this = this;
    let width = window.innerWidth;
    const btnStickyMobile = this.querySelector(".button-trigger__sticky");
    if (width < 768 && btnStickyMobile) {
      btnStickyMobile.addEventListener("click", () => {
        this.url = this.dataset.url;
        fetch(this.url)
          .then((response) => response.text())
          .then((text) => {
            const parser = new DOMParser();
            const html = parser
              .parseFromString(text, 'text/html')
              .querySelector('#shopify-section-product-quickview .product-quickview__content');
            if (!html) return;
  
            const div = document.createElement('div');
            div.classList.add('product-popup-mobile', 'show-overlay');
  
            _this.loadScripts(html);
            html.classList.remove('hidden');
  
            div.appendChild(html);
            document.body.appendChild(div);
            div.addEventListener('click', () => {
              this.closeContentMobile(div);
            });
            html.addEventListener('click', (event) => {
              event.stopPropagation();
            });
            setTimeout(() => {
              div.classList.add('open');
              document.querySelector('html').classList.add('overflow-hidden');
            }, 1);
          })
          .finally(() => {
            Shopify.PaymentButton.init();
          })
          .catch((e) => {
            console.error(e);
          });
      });
    }
  }
  loadScripts(html) {
    const scripts = html.querySelectorAll('script');
    scripts.forEach((script) => {
      const newScript = document.createElement('script');
      newScript.src = script.src;
      newScript.textContent = script.textContent;
      document.body.appendChild(newScript).parentNode.removeChild(newScript);
    });
  }
  closeContentMobile(div) {
    document.querySelector('html').classList.remove('overflow-hidden');
    div.classList.remove('open');
    setTimeout(() => {
      div.remove();
    }, 500);
  }
}
customElements.define("sticky-add-cart", StickyAddCart);
// js for fake sold
class SoldProduct extends HTMLElement {
  constructor() {
    super();
    this.sold = this.dataset.sold;
    this.hours = this.dataset.hours;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.sold && this.hours) {
      var message = "";
      message = this.message
        .replace("{{ sold }}", this.randomSelect(this.sold))
        .replace("{{ hours }}", this.randomSelect(this.hours));
      this.innerHTML += message;
    }
  }

  randomSelect(numbers) {
    const numberArray = numbers.split(",");
    const randomIndex = Math.floor(Math.random() * numberArray.length);
    const randomNumber = numberArray[randomIndex];
    return randomNumber;
  }
}
customElements.define("sold-product", SoldProduct);

// js for live view
class LiveView extends HTMLElement {
  constructor() {
    super();
    this.min = this.dataset.min;
    this.max = this.dataset.max;
    this.interval = this.dataset.interval;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.max && this.min && this.interval) {
      this.handle();
      setInterval(() => {
        this.handle();
      }, this.interval * 1000);
    }
  }

  handle() {
    var message = "";
    message = this.message.replace(
      "[count]",
      this.randomSelect(parseInt(this.min), parseInt(this.max))
    );
    this.innerHTML = message;
  }

  randomSelect(min, max) {
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomNumber;
  }
}
customElements.define("live-view", LiveView);



class CompareRadios extends SwatchInit {
  constructor() {
    super();
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.init();
    this.initFunction();
  }

  initFunction() {
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      btn.addEventListener("click", this.onVariantChange.bind(this), false);
    });
  }

  async onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    target.classList.toggle("active");
    await this.handleWhenSwatchUpdate();
  }

  collectActiveValues() {
    this.options = Array.from(
      this.querySelectorAll(".product__color-swatches--js.active"),
      (swatch) => swatch.dataset.value
    );
  }

  async handleWhenSwatchUpdate() {
    this.collectActiveValues();
    let arrayItem = this.updateMasterId(this.variantData);
    if (arrayItem.length !== this.options.length) {
      const resolvedItems = await this.resolveVariantsByOptionValueId();
      if (resolvedItems.length > 0) {
        arrayItem = resolvedItems;
      }
    }
    this.handleMediaCompare(arrayItem);
  }

  async resolveVariantsByOptionValueId() {
    const activeSwatches = Array.from(
      this.querySelectorAll(".product__color-swatches--js.active")
    );
    if (activeSwatches.length === 0) return [];
    const variantsMap = new Map();
    for (const swatch of activeSwatches) {
      const optionValueId = swatch.dataset.optionValueId;
      if (!optionValueId) continue;
      const variant = await this.fetchVariantByOptionValueId(optionValueId);
      if (!variant?.id) continue;
      const key = String(variant.id);
      if (!variantsMap.has(key)) {
        variantsMap.set(key, variant);
      }
    }
    return Array.from(variantsMap.values());
  }

  async fetchVariantByOptionValueId(optionValueId) {
    const productUrl = this.dataset.url;
    const sectionId = this.dataset.section || "cart-quick-edit";
    if (!productUrl || !optionValueId) return null;
    try {
      if (
        typeof VariantAPI !== "undefined" &&
        typeof VariantAPI.fetchByOptionValues === "function"
      ) {
        const result = await VariantAPI.fetchByOptionValues(
          productUrl,
          sectionId,
          [optionValueId]
        );
        if (result?.variant) return result.variant;
      }

      const params = new URLSearchParams();
      params.set("section_id", sectionId);
      params.set("ajax", "1");
      params.set("option_values", optionValueId);
      const response = await fetch(`${productUrl}?${params.toString()}`);
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, "text/html");
      const script = doc.querySelector("script[data-selected-variant]");
      if (!script) return null;
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn("compare-radios resolve variant failed", error);
      return null;
    }
  }

  handleMediaCompare(arrayItem) {
    if (!arrayItem || arrayItem.length === 0) return;
    const html = `
            ${arrayItem
              .map((item) => {
                const src =
                  item?.featured_media?.preview_image?.src ||
                  item?.featured_image?.src;
                if (!src) return "";
                const alt =
                  item?.featured_media?.alt ||
                  item?.featured_image?.alt ||
                  item?.title ||
                  "product";
                return `
                <div class="compare__items-inner">
                        <img width="300px" height="300px" src="${src}" alt="${alt}">
                        <p class="mb-0 mt-10 heading-style capitalize">${item.title}</p></div>
                    `;
              })
              .join("")}
        `;
    const compareColorContent = this.closest(".compare-colors__content");
    if (!compareColorContent) return;
    const compareItems = compareColorContent.querySelector(".compare__items");
    if (!compareItems) return;
    compareItems.innerHTML = html;
  }

  updateMasterId(variantData) {
    let arrayItem = [];
    this.options.forEach((option) => {
      const matchingVariant = variantData.find((variant) => {
        return variant.options.includes(option);
      });
      if (matchingVariant) {
        arrayItem.push(matchingVariant);
      }
    });
    return arrayItem;
  }
}
customElements.define("compare-radios", CompareRadios);

async function resolveVariantByOptionValueId(productUrl, optionValueId, sectionId = "cart-quick-edit") {
  if (!productUrl || !optionValueId) return null;
  try {
    if (
      typeof VariantAPI !== "undefined" &&
      typeof VariantAPI.fetchByOptionValues === "function"
    ) {
      const result = await VariantAPI.fetchByOptionValues(productUrl, sectionId, [optionValueId]);
      if (result?.variant) return result.variant;
    }

    const params = new URLSearchParams();
    params.set("section_id", sectionId);
    params.set("ajax", "1");
    params.set("option_values", optionValueId);
    const response = await fetch(`${productUrl}?${params.toString()}`);
    const text = await response.text();
    const doc = new DOMParser().parseFromString(text, "text/html");
    const script = doc.querySelector("script[data-selected-variant]");
    if (!script) return null;
    return JSON.parse(script.textContent);
  } catch (error) {
    console.warn("resolveVariantByOptionValueId failed", error);
    return null;
  }
}

async function hydrateSelectOptionVariant(select, option) {
  if (!select || !option) return null;
  const optionValueId = option.dataset.optionValueId;
  if (!optionValueId) return null;
  if (option.dataset.variantResolved === "true" && option.value) return null;

  const productUrl = select.dataset.url;
  const variant = await resolveVariantByOptionValueId(
    productUrl,
    optionValueId,
    "cart-quick-edit"
  );
  if (!variant) return null;

  const variantId = `${variant.id}`;
  const price = `${variant.price ?? 0}`;
  const comparePrice = `${variant.compare_at_price ?? variant.price ?? 0}`;
  const imageSrc =
    variant?.featured_media?.preview_image?.src ||
    variant?.featured_image?.src ||
    "";

  option.value = variantId;
  option.dataset.variantResolved = "true";
  option.setAttribute("data-price", price);
  option.setAttribute("data-compare-price", comparePrice);
  option.setAttribute("data-option", variant.title || option.textContent.trim());
  if (imageSrc) {
    option.setAttribute("data-image", imageSrc);
  }

  if (option.selected) {
    select.value = variantId;
  }
  select.setAttribute("data-price", price);
  select.setAttribute("data-compare-price", comparePrice);
  return variant;
}

async function hydrateSelectedVariantOptions(root) {
  if (!root) return;
  const selects = root.querySelectorAll(".product-variant-option");
  for (const select of selects) {
    if (!select.options || select.options.length === 0) continue;
    const selectedOption = select.options[select.selectedIndex];
    await hydrateSelectOptionVariant(select, selectedOption);
  }
}

class ProductRecommendations extends SlideSection {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          if (recommendations.innerHTML.trim().length === 0) {
            this.remove();
            if (document.querySelectorAll(".product-recommendations-heading").length > 0) {
              document
                .querySelectorAll(".product-recommendations-heading").forEach((item) => {
                  item.remove();
                });
            }
          }
        })
        .finally(() => {
          if (this.querySelector(".swiper-wrapper")) {
            this.initSlide();
            BlsAnimations.innit();
          }
          initLazyloadItem();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

// js for live view
class SkeletonPage extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    window.setTimeout(() => {
      this.classList.remove("skeleton");
    }, 1500);
  }
}
customElements.define("skeleton-page", SkeletonPage);

// js for live view
class ProductGrouped extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    var group = this.querySelector('.productGroup[type="application/json"]');
    if (!group) return;
    var variantData = JSON.parse(group.innerText);
    var query = "";
    variantData.forEach((e, key, variantData) => {
      if (!Object.is(variantData.length - 1, key)) {
        query += e + "%20OR%20id:";
      } else {
        query += e;
      }
    });
    var productAjaxURL = "?q=id:" + query + "&section_id=product-grouped";
    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then(async (responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.innerHTML = html.querySelector(".product-group").innerHTML;
      })
      .catch((e) => {
        throw error;
      })
      .finally(() => {
        this.eventProductGroupAction();
      });
  }

  eventProductGroupAction() {
    document
      .querySelectorAll(".product-group-list .product-variant-option")
      .forEach((select) => {
        select.addEventListener(
          "change",
          async (event) => {
            const target = event.target;
            const selectedOption = target.options[target.selectedIndex];
            await hydrateSelectOptionVariant(target, selectedOption);

            const image = selectedOption.getAttribute("data-image");
            const price = Number(selectedOption.getAttribute("data-price") || 0);
            const compare_price = Number(
              selectedOption.getAttribute("data-compare-price") || price
            );
            const pro_handle = target.getAttribute("data-handle");
            const img = target
              .closest(".product-group-list")
              .querySelector(".product-group-item ." + pro_handle + "")
              ?.querySelector("img");
            if (img && image) {
              img.removeAttribute("srcset");
              img.setAttribute("src", image);
            }
            const productTarget = target.closest(".product-group-item");
            const bls__price = productTarget.querySelector(
              ".product-item__price .card-product-price"
            );
            if (bls__price) {
              if (!bls__price.querySelector(".compare-price")) {
                var ps = document.createElement("div");
                var sp = document.createElement("span");
                var cp = document.createElement("s");
                cp.classList.add("price-item", "compare-price");
                sp.appendChild(cp);
                ps.appendChild(sp);
                ps.classList.add("price-regular");
                if (productTarget.querySelector(".card-product-price")) {
                  productTarget
                    .querySelector(".card-product-price")
                    .appendChild(ps);
                }
              }
              const cpp = bls__price.querySelector(".compare-price");

              if (cpp) {
                if (compare_price && compare_price > price) {
                  const compare_format = Shopify.formatMoney(
                    compare_price,
                    window.themeGlobalVariables.settings.money_default_format
                  );
                  cpp.innerHTML = compare_format;
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.add("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.add("price--special");
                  }
                } else {
                  cpp.innerHTML = "";
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.remove("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price.querySelector(
                      ".price-regular .price"
                    ).innerHTML = Shopify.formatMoney(
                      price,
                      cartStrings.money_format
                    );
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.remove("price--special");
                  }
                }
              }
            }
            target.setAttribute("data-price", `${price}`);
            target.setAttribute("data-compare-price", `${compare_price}`);
          },
          false
        );
      });

    let totalQty = 0;
    const classQty = document.querySelectorAll(
      ".quantity__input-product-group"
    );
    classQty.forEach((input) => {
      let valueQtyDefault = input.value;
      let valueAsDefault = parseFloat(valueQtyDefault);
      if (!isNaN(valueAsDefault)) {
        totalQty += valueAsDefault;
      }
      input.addEventListener("change", () => {
        totalQty = 0;
        classQty.forEach((value) => {
          let valueQty = value.value;
          let valueAsQty = parseFloat(valueQty);
          if (!isNaN(valueAsQty)) {
            totalQty += valueAsQty;
          }
        });
      });
    });
    document.querySelectorAll(".product-group-submit").forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          if (totalQty === 0) {
            const content = document.querySelector(
              ".form-infor .add-cart-error"
            );
            const messageErrQty = button.getAttribute("data-add-cart-err-qty");
            handleErrorMessagePopup(messageErrQty);
            if (!content) return;
          } else {
            this.submitProductGroup(event);
          }
        },
        false
      );
    });

    document.querySelectorAll(".product-group-buy-now").forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          if (totalQty === 0) {
            const content = document.querySelector(
              ".form-infor .add-cart-error"
            );
            const messageErrQty = button.getAttribute("data-add-cart-err-qty");
            handleErrorMessagePopup(messageErrQty);
            if (!content) return;
          } else {
            this.submitNowProductGroup(event);
          }
        },
        false
      );
    });
  }

  async submitNowProductGroup(event) {
    event.preventDefault();
    const form = document.getElementById("form-product-grouped");
    await hydrateSelectedVariantOptions(form);
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    config.body = formData;
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.items) {
          window.location.href = "/checkout";
        } else {
          const content = document.querySelector(".form-infor .add-cart-error");
          if (!content) return;
        }
      })
      .catch((e) => {
        throw e;
      });
  }

  async submitProductGroup(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const form = document.getElementById("form-product-grouped");
    await hydrateSelectedVariantOptions(form);
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    let openMiniCart = 0;
    const formData = new FormData(form);
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;
    target.classList.add("loading");
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll(".cart-count").forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                "free-ship-progress-bar"
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        const parsedState = JSON.parse(state);
        if (parsedState.message) {
          handleErrorMessagePopup(parsedState.description);
          if (!content) return;
        } else {
          parsedState.items.forEach((e) => {
            if (e.quantity > 0) {
              openMiniCart = 1;
            }
          });
          renderMinicartSections(cart, parsedState.sections);
          updateMinicartCountdown(cart, parsedState.sections);
          cart.cartAction();
        }
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove("loading");
        if (openMiniCart === 1) {
          cart.open();
        }
        const cartRecommend = document.querySelector(".cart-recommend");
        if (
          cartRecommend &&
          !cartRecommend.classList.contains("hidden-recommend")
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add("open");
              }, 800);
            } else if (cartUpsellSlide.length === 0){
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          }else{
            setTimeout(function () {
              cartRecommend.classList.add("open");
            }, 800);
          }
        }
      });
  }
}
customElements.define("product-group", ProductGrouped);

// js for product addons
class ProductAddons extends PopupBase {
  constructor() {
    super();
    this.productPopupDiv = this.querySelector(".product-addons__content");
    this.init();
  }
  init() {
    if (this.productPopupDiv) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    const html = this.productPopupDiv;
    if (!html) return;
    html.classList.remove("hidden");
    this.initPopup(
      html,
      `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${this.dataset?.textHeader}</h3>`
    );
  }
}
customElements.define("product-addons", ProductAddons);

class SwatchDropdown extends HTMLElement {
  constructor() {
    super();
    this.spanFor = this.dataset.spanFor;
    this.init();
  }
  init() {
    if (!this.spanFor) return;
    this.addEventListener("click", this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.querySelector(`#${this.spanFor}`).classList.contains("active")) {
      this.querySelector(`#${this.spanFor}`).classList.remove("active");
    } else {
      this.querySelector(`#${this.spanFor}`).classList.add("active");
    }
  }
}
customElements.define("swatch-dropdown", SwatchDropdown);

class ProductBoughtTogether extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const boughTogether = document.querySelector(
      '.productBoughTogether[type="application/json"]'
    );
    if (!boughTogether) return;
    const variantData = JSON.parse(boughTogether.innerText);
    let query = "";
    variantData.forEach((e, key, variantData) => {
      if (!Object.is(variantData.length - 1, key)) {
        query += e + "%20OR%20id:";
      } else {
        query += e;
      }
    });
    const productAjaxURL =
      "?q=id:" + query + "&section_id=product-bough-together";
    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then(async (responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        document.getElementById("product-bought-together").innerHTML =
          html.querySelector(".bought-together").innerHTML;
      })
      .catch((e) => {
        throw error;
      })
      .finally(() => {
        this.eventProductBoughTogetherAction();
      });
  }
  eventProductBoughTogetherAction() {
    var _this = this;
    document
      .querySelectorAll(".bought-together-checkbox")
      .forEach((checkbox) => {
        checkbox.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var total_price = 0,
              total_compare_price = 0,
              save_price = 0,
              price,
              compare_price,
              pro_handle = event.target.getAttribute("data-handle");
            var img = target
              .closest("#product-bought-together")
              .querySelector(".product-bought-image-item." + pro_handle + "");
            if (target.checked) {
              img.classList.add("select");
              target
                .closest(".product-bought-together-item")
                .classList.add("select");
              target
                .closest(".product-bought-together-item")
                .querySelector(".product-variant-option")
                .removeAttribute("disabled");
              target
                .closest(".product-bought-together-item")
                .querySelector(".quantity")
                .removeAttribute("disabled");
            } else {
              img.classList.remove("select");
              target
                .closest(".product-bought-together-item")
                .classList.remove("select");
              target
                .closest(".product-bought-together-item")
                .querySelector(".product-variant-option")
                .setAttribute("disabled", true);
              target
                .closest(".product-bought-together-item")
                .querySelector(".quantity")
                .setAttribute("disabled", true);
            }
            setTimeout(function () {
              var bought_together_select = document.querySelectorAll(
                ".product-bought-together-item.select"
              );
              bought_together_select.forEach((item) => {
                var option = item.querySelector(".product-variant-option");
                price = option.getAttribute("data-price");
                compare_price = option.getAttribute("data-compare-price");
                total_price = total_price + Number(price);
                total_compare_price =
                  total_compare_price + Number(compare_price);
              });
              save_price = total_compare_price - total_price;
              _this.eventProductBoughTogetherUpdatePrice(
                total_price,
                total_compare_price,
                save_price
              );
              if (bought_together_select.length <= 1) {
                document
                  .querySelector(".bought-together-submit")
                  .setAttribute("disabled", true);
              } else {
                document
                  .querySelector(".bought-together-submit")
                  .removeAttribute("disabled");
              }
            }, 50);
          },
          false
        );
      });
    document
      .querySelectorAll("#product-bought-together .product-variant-option")
      .forEach((select) => {
        select.addEventListener(
          "change",
          async (event) => {
            const target = event.target;
            const selectedOption = target.options[target.selectedIndex];
            await hydrateSelectOptionVariant(target, selectedOption);

            let total_price = 0;
            let total_compare_price = 0;
            const image = selectedOption.getAttribute("data-image");
            const price = Number(selectedOption.getAttribute("data-price") || 0);
            const compare_price = Number(
              selectedOption.getAttribute("data-compare-price") || price
            );
            const pro_handle = target.getAttribute("data-handle");
            const img = target
              .closest("#product-bought-together")
              .querySelector(".product-bought-image-item." + pro_handle + "")
              ?.querySelector("img");
            if (img && image) {
              img.removeAttribute("srcset");
              img.setAttribute("src", image);
            }
            const productTarget = target.closest(
              ".product-bought-together-item"
            );
            const bls__price = productTarget.querySelector(
              ".product-item__price .card-product-price"
            );
            if (bls__price) {
              if (!bls__price.querySelector(".compare-price")) {
                var ps = document.createElement("div");
                var sp = document.createElement("span");
                var cp = document.createElement("s");
                cp.classList.add("price-item", "compare-price");
                sp.appendChild(cp);
                ps.appendChild(sp);
                ps.classList.add("price-regular");
                if (productTarget.querySelector(".card-product-price")) {
                  productTarget
                    .querySelector(".card-product-price")
                    .appendChild(ps);
                }
              }
              const cpp = bls__price.querySelector(".compare-price");

              if (cpp) {
                if (compare_price && compare_price > price) {
                  const compare_format = Shopify.formatMoney(
                    compare_price,
                    window.themeGlobalVariables.settings.money_default_format
                  );
                  cpp.innerHTML = compare_format;
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.add("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.add("price--special");
                  }
                } else {
                  cpp.innerHTML = "";
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.remove("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price.querySelector(
                      ".price-regular .price"
                    ).innerHTML = Shopify.formatMoney(
                      price,
                      cartStrings.money_format
                    );
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.remove("price--special");
                  }
                }
              }
            }
            target.setAttribute("data-price", `${price}`);
            target.setAttribute("data-compare-price", `${compare_price}`);
            document
              .querySelectorAll(".product-bought-together-item.select")
              .forEach((item) => {
                const option = item.querySelector(".product-variant-option");
                const optionPrice = Number(option.getAttribute("data-price") || 0);
                const optionComparePrice = Number(
                  option.getAttribute("data-compare-price") || optionPrice
                );
                total_price += optionPrice;
                total_compare_price += optionComparePrice;
              });
            const save_price = total_compare_price - total_price;
            _this.eventProductBoughTogetherUpdatePrice(
              total_price,
              total_compare_price,
              save_price
            );
          },
          false
        );
      });

    document.querySelectorAll(".bought-together-submit").forEach((button) => {
      button.addEventListener(
        "click",
        this.submitBoughtTogether.bind(this),
        false
      );
    });
  }
  async submitBoughtTogether(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const form = document.getElementById("bought-together-form");
    await hydrateSelectedVariantOptions(form);
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;
    target.classList.add("loading");
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll(".cart-count").forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                "free-ship-progress-bar"
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        const parsedState = JSON.parse(state);
        if (parsedState.message) {
          handleErrorMessagePopup(parsedState.description);
          return;
        }
        renderMinicartSections(cart, parsedState.sections);
        updateMinicartCountdown(cart, parsedState.sections);
        cart.cartAction();
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove("loading");
        cart.open();
        const cartRecommend = document.querySelector(".cart-recommend");
        if (
          cartRecommend &&
          !cartRecommend.classList.contains("hidden-recommend")
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add("open");
              }, 800);
            } else if (cartUpsellSlide.length === 0){
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          }else{
            setTimeout(function () {
              cartRecommend.classList.add("open");
            }, 800);
          }
        }
      });
  }

  eventProductBoughTogetherUpdatePrice(
    total_price,
    total_compare_price,
    save_price
  ) {
    var total = document.querySelector("#product-bought-together .box-total");
    if (total) {
      total.querySelector(".saved-price .price").innerHTML =
        Shopify.formatMoney(save_price, cartStrings.money_format);
      total.querySelector(".total-price .price__sale .price-item").innerHTML =
        Shopify.formatMoney(total_compare_price, cartStrings.money_format);
      total.querySelector(".total-price .price").innerHTML =
        Shopify.formatMoney(total_price, cartStrings.money_format);
      if (total_compare_price > total_price) {
        total.querySelector(".total-price").classList.add("price--on-sale");
        total
          .querySelector(".total-price .price")
          .classList.add("special-price");
      } else {
        total.querySelector(".total-price").classList.remove("price--on-sale");
        total
          .querySelector(".total-price .price")
          .classList.remove("special-price");
      }
      if (save_price > 1) {
        total.querySelector(".saved-price").classList.remove("hidden");
      } else {
        total.querySelector(".saved-price").classList.add("hidden");
      }
    }
  }
}
customElements.define("product-bought-together", ProductBoughtTogether);

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];

    var currentProductID = productJson.id.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "glozin__recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "glozin__recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    var productJson = JSON.parse(prodData.innerHTML);
    var storedProducts = JSON.parse(
      localStorage.getItem("glozin__recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }

  queueMobileProductSummarySync(document);
});

window.addEventListener("resize", function () {
  queueMobileProductSummarySync(document);
});

document.addEventListener("shopify:section:load", function (event) {
  queueMobileProductSummarySync(event.target);
});
var BlsDropDownProduct = (function () {
  return {
    innit: function () {
      var custom_select = document.querySelectorAll(".custom-select");
      if (custom_select) {
        custom_select.forEach((item) => {
          let select__selected = item.querySelector(".select__selected");
          select__selected.addEventListener("click", (e) => {
            let dropdown = e.target.nextElementSibling;
            dropdown.classList.toggle("hidden");
          });
        });
      }
      document.addEventListener("click", function (event) {
        if (!event.target.closest(".custom-select")) {
          document.querySelectorAll(".select__dropdown")?.forEach((item) => {
            item.classList.add("hidden");
          });
        }
      });
    },
  };
})();

BlsDropDownProduct.innit();

var SyncQuantityInput = (() => {
  return {
    init: () => {
      const syncInputs = document.querySelectorAll(
        ".product-detail__buy-buttons input.quantity-input"
      );
      syncInputs.forEach((input) => {
        input.addEventListener("change", function () {
          const value = this.value;
          syncInputs.forEach((otherInput) => {
            if (otherInput !== input) {
              otherInput.value = value;
            }
          });
        });
      });
    },
  };
})();

SyncQuantityInput.init();

class SlideSectionProductSet extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: document.querySelector(".swiper-pagination-product-set"),
        type: "custom",
        renderCustom: function (swiper, current, total) {
          return current + "/" + total;
        }
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
        },
      },

      on: {
        init: function () {
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
        }
      },
    });
  }
}
customElements.define("slide-section-product-set", SlideSectionProductSet);

var BlsShowMoreColors = (function () {
  return {
    init: function () {
      this.showMore();
      this.showLess();
    },
    showMore: function(){
      const show_more_colors = document.querySelector(".show_more_colors");
      const show_less_more_colors = document.querySelector(".show_less_more_colors");
      if(show_more_colors != null){
        show_more_colors.addEventListener("click", (e) => {
          e.currentTarget.classList.add("hidden");
          show_less_more_colors.classList.remove("hidden");
          document.querySelectorAll(".more-colors-product_item.hidden").forEach((btn) => {
            btn.classList.remove("hidden");
            btn.classList.add("less-style");
            setTimeout(() =>{   
              btn.classList.remove("opacity-0")
            }, 100)
          
          });
        })
      }
    },
    showLess: function(){
      const show_more_colors = document.querySelector(".show_more_colors");
      const show_less_more_colors = document.querySelector(".show_less_more_colors");
      if(show_less_more_colors != null){
        show_less_more_colors.addEventListener("click", (e) => {
          e.currentTarget.classList.add("hidden");
          show_more_colors.classList.remove("hidden");
          document.querySelectorAll(".more-colors-product_item.less-style").forEach((btn) => {
            btn.classList.add("hidden");
            btn.classList.add("opacity-1")
          });
        })
      }
    }
  };
})();

BlsShowMoreColors.init();
